import Auth from 'utils/Auth';
import { buildRoute } from 'routes';
import { Navigate, Outlet } from 'react-router-dom';

export default function GuestRoutes() {
  return Auth.isLoggedIn() ? <Navigate to={buildRoute('home')} /> : <Outlet />;
}
